module.exports = __webpack_public_path__ + "static/media/mari-logo-1.ab6cefaa.png";